// Initialize Sentry FIRST so any error during the AngularJS bootstrap is captured.
import { MonitoringUtils } from './app/monitoring/monitoringUtils.js';
import { AnalyticsUtils } from './app/analytics/analyticsUtils.js';
import { environment } from './environments/environment';

MonitoringUtils.init({
    dsn: environment.sentry?.dsn,
    environment: environment.environment,
    release: environment.buildId,
});

AnalyticsUtils.init({
    appName: 'quartz-gov-legacy',
    environment: environment,
});

// FileAPI
FileAPI = {
    jsPath: './assets/vendor/angular-file-upload/',
    staticPath: './assets/vendor/angular-file-upload/'
};

import './styles.css';
import './app/shared.js';
import './app/main.js';
import './app/templates.js';

import './app/app.js';
import './app/authService.js';
import './app/auth/auth0Provider.js';
import './app/auth/keycloakProvider.js';
import './app/auth/keycloakInterceptor.js';
